import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { CsvImportInterface } from '../../store/callrecorder/csvImportsSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.csvImportPath(value.id),
    csv_file_url: callrecorderUrls.remoteUrl(value.csv_file_url)
  };
}

export const csvImportsEntity = new schema.Entity(
  'csv_imports',
  {},
  {
    processStrategy
  }
);

export const csvImportEntity = new schema.Entity(
  'csv_import',
  {},
  {
    processStrategy
  }
);

const fetchCsvImportsCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      csv_imports: { [key: string]: CsvImportInterface };
    }
  >(response.data.csv_imports, [csvImportsEntity]);

  return {
    csvImports: normalized.entities?.csv_imports || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { csv_import: CsvImportInterface; }
  >(response.data.csv_import, csvImportEntity);
  return normalized.entities;
}

export const fetchCsvImports = createAsyncThunk(
  `${PREFIX}_csv_imports/fetchCsvImports`,
  async (params: object = {}) => fetchCsvImportsCollection('/onesky/csv_imports', params)
);

export const fetchCsvImport = createAsyncThunk(
  `${PREFIX}_csv_imports/fetchCsvImport`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/csv_imports/${id}`);
    return normalizeInstance(response);
  }
);

export const createCsvImport = createAsyncThunk(
  `${PREFIX}_csv_imports/createCsvImport`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.post(`/onesky/csv_imports`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
